import styles from './PageNotAccsess.module.scss'

const PageNotAccsess = () => {
  return (
    <div className={styles.container}>
      <p>not_access_page</p>
    </div>
  )
}

export default PageNotAccsess
